import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';

import { Dialog } from '@/components/Dialog';
import { ArcadeEmbed } from '@/features/ExplainerVideo/components/ArcadeEmbed';

interface ExplainerVideoModalProps {
  open: boolean;
  onClose: () => void;
}

export const ExplainerVideoModal = ({ open, onClose }: ExplainerVideoModalProps) => (
  <Dialog
    open={open}
    sx={{ minWidth: 800 }}
    transitionDuration={0}
    onClose={onClose}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }}
    >
      <IconButton
        aria-label='close'
        onClick={onClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </Box>
    <ArcadeEmbed />
  </Dialog>
);
